import type { ScreenReport, AidenResponse, Attribute, Entity } from "../types"

const calculateProgress = (
  screenReports: ScreenReport[],
  currentScreenId: string
) => {
  const screens = screenReports.filter((scr) => {
    const id = scr.id.toLowerCase()
    return scr.relevant && id !== "intro" && id !== "advice"
  })
  const total = screens.length
  const completed = screens.filter(
    (scr) => scr.complete && scr.id != currentScreenId
  ).length
  return total ? (completed / total) * 100 : 0
}

const getAttribute = (
  data: AidenResponse,
  attributeInstanceId: string
): Attribute["value"] => {
  const { entityId } = parseAttributeInstanceId(attributeInstanceId)

  return (
    data?.entities
      ?.find((e) => e.id === entityId)
      ?.attributes?.find((a) => a.id === attributeInstanceId)?.value || null
  )
}

const setAttribute = (
  data: AidenResponse,
  attributeInstanceId: string,
  value: string | string[] | null | number
): AidenResponse => {
  return {
    ...data,
    entities: updateForEntity(data.entities, attributeInstanceId, value),
  }
}

const updateForEntity = (
  entities: Entity[],
  attributeInstanceId: string,
  value: string | string[] | null | number
): Entity[] => {
  const { entityId } = parseAttributeInstanceId(attributeInstanceId)

  const updatedEntities = entities.reduce((acc, entity) => {
    if (entity.id === entityId) {
      return [
        ...acc,
        {
          ...entity,
          attributes: entity.attributes.reduce((a, attribute) => {
            if (attribute.id === attributeInstanceId) {
              return [...a, { ...attribute, value: value }]
            } else {
              return [...a, attribute]
            }
          }, [] as Attribute[]),
        },
      ]
    } else {
      return [...acc, entity]
    }
  }, [] as Entity[])

  return updatedEntities
}

const parseAttributeInstanceId = (attributeInstanceId: string) => {
  let attributeId: string | null = null
  let entityId: string | null = null

  // eslint-disable-next-line no-useless-escape
  const match = attributeInstanceId.match(/([a-z0-9\-]+)@(\w+\$\d+)/)

  if (match) {
    attributeId = match[1]
    entityId = match[2]
  }

  return {
    attributeId,
    entityId,
  }
}

export default {
  calculateProgress,
  getAttribute,
  setAttribute,
  updateForEntity,
}
